var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v(_vm._s(_vm.$t('components.projects.projectDeposit')))]),_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":'/projectsDeposits/create?project_id=' + _vm.$route.params.id}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('components.projects.addition'))+" ")])],1),_c('indexTable',{attrs:{"searchText":_vm.$t('projectsDeposits.searchForAnProjectsDepositsOperations'),"emptyTableText":_vm.$t('projectsDeposits.thereAreNoprojectsDepositsOperations'),"filter":{project_id: _vm.$route.params.id},"emptyTableSubText":_vm.$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain'),"withoutCard":true,"cloumns":[
        {
          column: 'code',
          title: _vm.$t('projectsDeposits.operation'),
          type: 'mainLink',
          sort: true,
        },
        {
          column: 'project_id',
          title: _vm.$t('projectsDeposits.projectName'),
          type: 'link',
          to: 'project',
          sort: true,
          link: true,
        },
        {
          column: 'store_id',
          title: _vm.$t('projectsDeposits.storeName'),
          type: 'link',
          to: 'store',
          sort: true,
          link: true,
        },
        {
          column: 'date',
          title: _vm.$t('projectsDeposits.theDateOfTheOperation'),
          type: 'text',
          sort: true,
        },
        { column: 'total', title: _vm.$t('components.projects.total'), type: 'text', sort: true },
        {
          column: 'description',
          title: _vm.$t('projectsDeposits.thatIsAbout'),
          type: 'text',
          sort: true,
        },
        {
          column: 'options',
          title: _vm.$t('projectsDeposits.settings'),
          type: 'options',
          options: [
            { name: 'show' },
            {
              name: 'edit',
              role:
                _vm.$user.admin ||
                _vm.$user.role.projects_deposits_edit,
            },
            { name: 'printProjectsDeposit', role: true },
            {
              name: 'delete',
              role:
                _vm.$user.admin ||
                _vm.$user.role.projects_deposits_delete,
            } ],
        } ],"deleteText":{
        attention: _vm.$t('allerts.Attention'),
        areYouReallySureToDeleteTheItem:
          _vm.$t('allerts.areYouReallySureToDeleteTheItem'),
        close: _vm.$t('allerts.close'),
        confirm: _vm.$t('allerts.confirm'),
        loading: _vm.$t('allerts.loading'),
      }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }